import {
  LEGACY_F29_MODULE_ID,
  defaultStaffModuleAccess,
  resolveStaffModuleAccess,
} from './staffModulePermissions';

/** Módulo /multas-sii — sincronizar con server_admin y smart_back */
export const MULTAS_SII_MODULE_ID = 'multas_sii';

export function defaultMultasSiiAccess(roles) {
  return defaultStaffModuleAccess(roles);
}

export function resolveMultasSiiAccess(userPerms, companyPerms, userCompanyPerms, roles) {
  return resolveStaffModuleAccess(
    MULTAS_SII_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
